﻿import { Component, Input, Output, Inject } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Severity, Impact } from "../../models/serviceCase";

@Component({
    module: FIQAssist,
    selector: "severityAssessment",
    templateUrl: "views/severityAssessment.html"
})
class SeverityAssessment {
    constructor() {

    }

    private uatrules: { down: boolean, pctclass: string, wo: boolean, max: Severity, initial: Severity }[] = [
        { down: true, pctclass: undefined, wo: undefined, max: 'level3', initial: 'level3' },

        { down: false, pctclass: 'high', wo: true, max: 'level3', initial: 'level4' },
        { down: false, pctclass: 'high', wo: false, max: 'level3', initial: 'level4' },

        { down: false, pctclass: 'medium', wo: true, max: 'level3', initial: 'level4' },
        { down: false, pctclass: 'medium', wo: false, max: 'level3', initial: 'level4' },

        { down: false, pctclass: 'low', wo: false, max: 'level3', initial: 'level4' },
        { down: false, pctclass: 'low', wo: true, max: 'level4', initial: 'level4' }
    ];

    private prodrules: { down: boolean, pctclass: string, wo: boolean, max: Severity, initial: Severity }[] = [
        { down: true, pctclass: undefined, wo: undefined, max: 'level1', initial: 'level1' },

        { down: false, pctclass: 'high', wo: false, max: 'level2', initial: 'level2' },
        { down: false, pctclass: 'high', wo: true, max: 'level3', initial: 'level3' },

        { down: false, pctclass: 'medium', wo: false, max: 'level3', initial: 'level3' },
        { down: false, pctclass: 'medium', wo: true, max: 'level3', initial: 'level4' },

        { down: false, pctclass: 'low', wo: false, max: 'level3', initial: 'level4' },
        { down: false, pctclass: 'low', wo: true, max: 'level3', initial: 'level4' }
    ];

    private _down: boolean;
    private _impact: Impact;
    private _workaround: boolean;
    private _severity: Severity;
    private _isProd: boolean;

    @Input()
    public get down(): boolean {
        return this._down;
    }
    public set down(val: boolean) {
        this._down = val;
    }

    @Input()
    public get impact(): Impact {
        return this._impact;
    }
    public set impact(val: Impact) {
        this._impact = val;
    }

    @Input()
    public get workaround(): boolean {
        return this._workaround;
    }
    public set workaround(val: boolean) {
        this._workaround = val;
    }

    @Input()
    public get severity(): Severity {
        return this._severity;
    }
    public set severity(val: Severity) {
        this._severity = val;
    }

    @Input()
    public get isprod(): boolean { return this._isProd; }
    public set isprod(val: boolean) {
        let old = this._isProd;
        this._isProd = !!val;
        this.updateSeverity(old !== undefined && old !== this._isProd);
    }

    @Input() readOnly: boolean;

    @Output() public onseveritychanged: (args: { severity: Severity, down: boolean, workaround: boolean; impact: Impact }) => void;

    public get showimpacted() { return !this._down; }
    public get showworkaround() { return !this._down; }

    private maxSeverity: Severity = 'level4';

    onoptionchanged(group: string, value: any, text: string) {
        switch (group) {
            case 'down':
                this.down = value;
                if (value == true) {
                    this.impact = "low";
                    this.workaround = true;
                } else {
                    this.impact = this.impact;
                    this.workaround = this.workaround;
                }
                break;
            case 'impact':
                this.impact = value;
                break;
            case 'workaround':
                this.workaround = value;
                break;
        }
        this.updateSeverity();
    }

    SeverityChanged(severity: Severity) {
        let org = this.severity;
        this.severity = severity;
        if (org != this.severity)
            this.fireSeverityChanged();
    }

    updateSeverity(setInitial = true) {
        let { max, initial } = this.getSeverity(this.down, this.impact, this.workaround);
        this.maxSeverity = max;
        if (this.initialized && !this.readOnly && setInitial) {
            let org = this.severity;
            this.severity = initial;
            if (org != this.severity)
                this.fireSeverityChanged();
        }
    }

    private initialized: boolean;
    private $onInit() {
        this.initialized = true;
        this.updateSeverity();
    }

    private fireSeverityChanged() {
        if (!this.readOnly) {
            this.onseveritychanged({
                severity: this.severity,
                down: this.down,
                workaround: this.workaround,
                impact: this.impact
            });
        }
    }

    getSeverity(isDown: boolean, impact: string, workaround: boolean): { max: Severity, initial: Severity } {
        let rules = this._isProd ? this.prodrules : this.uatrules;
        if (rules) {
            let rule = rules.filter(r =>
                r.down === isDown &&
                (isDown ? r.pctclass === undefined : r.pctclass === impact) &&
                (isDown ? r.wo === undefined : r.wo === workaround)).shift();
            if (rule)
                return { max: rule.max, initial: rule.initial };
        }
        return { max: 'level4', initial: 'level4' };
    }
}
